import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _css from "@emotion/css";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { Component } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Group from '../../presentational/Group';
var defaultStyles = {
  minHeight: 64,
  // Remove browser default button styles for rbdnd placeholder
  '& > button': {
    background: 'none',
    border: 'none',
    padding: 'none'
  }
}; // This will automatically be applied for us as part of react-beautiful-dnd v10

var applyDraggingStyles = function applyDraggingStyles(snapshot) {
  return {
    pointerEvents: snapshot.isDraggingOver ? 'none' : undefined
  };
};

var SortableGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(SortableGroup, _Component);

  function SortableGroup() {
    _classCallCheck(this, SortableGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(SortableGroup).apply(this, arguments));
  }

  _createClass(SortableGroup, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      var _this$props = this.props,
          children = _this$props.children,
          innerStyle = _this$props.innerStyle,
          groupProps = _objectWithoutProperties(_this$props, ["children", "innerStyle"]);

      return ___EmotionJSX(Droppable, {
        droppableId: groupProps.id
      }, function (droppableProvided, snapshot) {
        return ___EmotionJSX("div", _extends({
          ref: droppableProvided.innerRef,
          css:
          /*#__PURE__*/
          _css(_objectSpread({}, defaultStyles, innerStyle, applyDraggingStyles(snapshot)), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
        }, droppableProvided.droppableProps), ___EmotionJSX(Group, groupProps, children, droppableProvided.placeholder));
      });
    }
  }]);

  return SortableGroup;
}(Component);

export { SortableGroup as default };